"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.object.values");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _contract = require("@/api/cms/contract");

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

var _default2 = {
  name: 'ContractQuotationInfo',
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      loading: false,
      quotationData: []
    };
  },
  watch: {
    contract: {
      handler: function handler(newVal) {
        if (newVal && newVal.contractNo) {
          this.init();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init: function init() {
      if (this.contract.contractNo) {
        this.fetchQuotationData(this.contract.contractNo);
      }
    },
    fetchQuotationData: function () {
      var _fetchQuotationData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contractNumber) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return (0, _contract.getOrderQuote)({
                  contractNumber: contractNumber
                });

              case 4:
                res = _context.sent;

                if (res.code === 200 && res.data) {
                  this.quotationData = res.data;
                } else {
                  this.quotationData = [];
                }

                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.error('获取报价信息失败:', _context.t0);
                this.quotationData = [];

              case 12:
                _context.prev = 12;
                this.loading = false;
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8, 12, 15]]);
      }));

      function fetchQuotationData(_x) {
        return _fetchQuotationData.apply(this, arguments);
      }

      return fetchQuotationData;
    }(),
    handleRowClick: function handleRowClick(row) {
      this.$refs.quotationTable.toggleRowExpansion(row);
    },
    getQuoteTotal: function getQuoteTotal(quotes) {
      if (!quotes || quotes.length === 0) return 0;
      return quotes.reduce(function (sum, item) {
        return sum + (item.totalAmount || 0);
      }, 0);
    },
    getGrandTotal: function getGrandTotal() {
      var _this = this;

      if (!this.quotationData || this.quotationData.length === 0) return 0;
      return this.quotationData.reduce(function (sum, row) {
        if (row.productionStatus === '取消') return sum;
        return sum + _this.getQuoteTotal(row.quotes);
      }, 0);
    },
    exportQuotations: function () {
      var _exportQuotations = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var ExcelJS, workbook, ws, borderStyle, infoLabelStyle, infoValueStyle, headerStyle, dataStyle, c, customerName, customerPhone, address, contractNo, cleanName, guideName, designerName, row1, r1Cells, row2, r2Cells, colWidths, headerTexts, headerRow, flatRows, groupMap, orderSubtotals, dataStartRow, buffer, blob, url, a, filename;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.quotationData || this.quotationData.length === 0)) {
                  _context2.next = 3;
                  break;
                }

                this.$message.warning('没有可导出的报价');
                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return Promise.resolve().then(function () {
                  return _interopRequireWildcard(require('exceljs'));
                });

              case 5:
                ExcelJS = _context2.sent;
                workbook = new ExcelJS.default.Workbook();
                workbook.creator = 'CRM';
                workbook.created = new Date();
                ws = workbook.addWorksheet('报价明细'); // ========== 通用样式定义 ==========

                borderStyle = {
                  top: {
                    style: 'thin'
                  },
                  left: {
                    style: 'thin'
                  },
                  bottom: {
                    style: 'thin'
                  },
                  right: {
                    style: 'thin'
                  }
                }; // 基础信息区样式

                infoLabelStyle = {
                  font: {
                    bold: true,
                    size: 11,
                    name: '微软雅黑'
                  },
                  alignment: {
                    horizontal: 'right',
                    vertical: 'middle'
                  },
                  border: borderStyle,
                  fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {
                      argb: 'FFF5F5F5'
                    }
                  }
                };
                infoValueStyle = {
                  font: {
                    size: 11,
                    name: '微软雅黑'
                  },
                  alignment: {
                    horizontal: 'left',
                    vertical: 'middle'
                  },
                  border: borderStyle
                }; // 表头样式

                headerStyle = {
                  fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {
                      argb: 'FF4472C4'
                    }
                  },
                  font: {
                    bold: true,
                    color: {
                      argb: 'FFFFFFFF'
                    },
                    size: 10,
                    name: '微软雅黑'
                  },
                  alignment: {
                    horizontal: 'center',
                    vertical: 'middle'
                  },
                  border: borderStyle
                }; // 数据行样式

                dataStyle = {
                  font: {
                    size: 10,
                    name: '微软雅黑'
                  },
                  alignment: {
                    horizontal: 'center',
                    vertical: 'middle'
                  },
                  border: borderStyle
                }; // ========== 一、文档顶部基础信息区 ==========

                c = this.contract || {};
                customerName = c.customerName || c.custName || c.contactPerson || c.name || '';
                customerPhone = c.customerPhone || c.contactNumber || c.mobile || c.phone || '';
                address = c.address || c.contactAddress || c.custAddress || '';
                contractNo = c.contractNo || ''; // 处理导购和设计师：可能为数组 ["xxx"] 或 JSON 字符串，去掉[]和引号

                cleanName = function cleanName(val) {
                  if (!val) return '';
                  if (Array.isArray(val)) return val.join(', ');
                  var str = String(val);

                  try {
                    var parsed = JSON.parse(str);
                    if (Array.isArray(parsed)) return parsed.join(', ');
                    return String(parsed);
                  } catch (_unused) {
                    return str;
                  }
                };

                guideName = cleanName(c.guideNickName || c.guideName);
                designerName = cleanName(c.designerNickName || c.designerName); // 第1行：客户信息（占满10列宽度）

                row1 = ws.addRow([]);
                row1.height = 26; // col1: "客户："标签, col2-4: 客户名, col5: "电话："标签, col6-7: 电话, col8: "地址："标签, col9-10: 地址

                r1Cells = [{
                  col: 1,
                  val: '客户：',
                  style: infoLabelStyle,
                  merge: null
                }, {
                  col: 2,
                  val: customerName,
                  style: infoValueStyle,
                  merge: [2, 4]
                }, {
                  col: 5,
                  val: '电话：',
                  style: infoLabelStyle,
                  merge: null
                }, {
                  col: 6,
                  val: customerPhone,
                  style: infoValueStyle,
                  merge: [6, 7]
                }, {
                  col: 8,
                  val: '地址：',
                  style: infoLabelStyle,
                  merge: null
                }, {
                  col: 9,
                  val: address,
                  style: infoValueStyle,
                  merge: [9, 10]
                }];
                r1Cells.forEach(function (_ref) {
                  var col = _ref.col,
                      val = _ref.val,
                      style = _ref.style,
                      merge = _ref.merge;
                  var cell = row1.getCell(col);
                  cell.value = val;
                  cell.style = style;
                  if (merge) ws.mergeCells(1, merge[0], 1, merge[1]);
                }); // 第2行：合同导购信息（占满10列宽度）

                row2 = ws.addRow([]);
                row2.height = 26;
                r2Cells = [{
                  col: 1,
                  val: '合同号：',
                  style: infoLabelStyle,
                  merge: null
                }, {
                  col: 2,
                  val: contractNo,
                  style: infoValueStyle,
                  merge: [2, 3]
                }, {
                  col: 4,
                  val: '导购：',
                  style: infoLabelStyle,
                  merge: null
                }, {
                  col: 5,
                  val: guideName,
                  style: infoValueStyle,
                  merge: [5, 6]
                }, {
                  col: 7,
                  val: '设计师：',
                  style: infoLabelStyle,
                  merge: null
                }, {
                  col: 8,
                  val: designerName,
                  style: infoValueStyle,
                  merge: [8, 10]
                }];
                r2Cells.forEach(function (_ref2) {
                  var col = _ref2.col,
                      val = _ref2.val,
                      style = _ref2.style,
                      merge = _ref2.merge;
                  var cell = row2.getCell(col);
                  cell.value = val;
                  cell.style = style;
                  if (merge) ws.mergeCells(2, merge[0], 2, merge[1]);
                }); // 空行分隔

                ws.addRow([]); // ========== 二、明细表格 ==========
                // 10列静态列宽

                colWidths = [18, 10, 20, 12, 6, 10, 10, 10, 10, 12];
                colWidths.forEach(function (w, i) {
                  ws.getColumn(i + 1).width = w;
                }); // 表头

                headerTexts = ['订单号', '类型', '品名', '报价方式', '厚', '数量', '计价数量', '单价', '小计', '订单小计'];
                headerRow = ws.addRow(headerTexts);
                headerRow.height = 22;
                headerRow.eachCell(function (cell) {
                  cell.style = headerStyle;
                }); // ========== 构建扁平数据行 ==========
                // flatRows: { productionOrder, cells[], orderTotal }

                flatRows = [];
                this.quotationData.forEach(function (item) {
                  var productionOrder = item.productionOrder || '';
                  var rows = [];

                  if (item.quotes && item.quotes.length > 0) {
                    item.quotes.forEach(function (q) {
                      var typeVal = q.priceType || q.type || '';
                      var priceMethod = q.priceRule || '';
                      var thickVal = q.thickness || q.thick || '';
                      var qty = q.quantity !== undefined ? q.quantity : q.qty !== undefined ? q.qty : '';
                      var vol = q.volume !== undefined ? Number(q.volume) : 0;
                      var price = q.unitPrice !== undefined ? Number(q.unitPrice) : 0;
                      var subtotal = vol * price;
                      rows.push({
                        productionOrder: productionOrder,
                        typeVal: typeVal,
                        name: q.name || '',
                        priceMethod: priceMethod,
                        thickVal: thickVal,
                        qty: qty,
                        vol: vol,
                        price: price,
                        subtotal: subtotal
                      });
                    });
                  }

                  flatRows.push.apply(flatRows, rows);
                }); // 按productionOrder分组

                groupMap = {};
                flatRows.forEach(function (r, idx) {
                  var key = r.productionOrder || '__no_order__';
                  if (!groupMap[key]) groupMap[key] = [];
                  groupMap[key].push(idx);
                }); // 计算每组订单小计

                orderSubtotals = {};
                Object.entries(groupMap).forEach(function (_ref3) {
                  var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
                      orderNo = _ref4[0],
                      indices = _ref4[1];

                  var sum = indices.reduce(function (acc, idx) {
                    return acc + flatRows[idx].subtotal;
                  }, 0);
                  orderSubtotals[orderNo] = sum;
                }); // 写入数据行

                flatRows.forEach(function (r, idx) {
                  var orderSubtotal = orderSubtotals[r.productionOrder || '__no_order__'] || 0;
                  var row = ws.addRow([r.productionOrder, r.typeVal, r.name, r.priceMethod, r.thickVal, r.qty, r.vol, r.price, r.subtotal, orderSubtotal]);
                  row.height = 20;
                  row.eachCell(function (cell, colIdx) {
                    cell.style = dataStyle; // 金额列（单价、小计、订单小计）右对齐

                    if ([8, 9, 10].includes(colIdx) && cell.value !== '' && cell.value !== undefined) {
                      cell.alignment = {
                        horizontal: 'right',
                        vertical: 'middle'
                      };
                      cell.numFmt = '#,##0.00';
                    } // 数量、计价数量 右对齐


                    if ([6, 7].includes(colIdx) && cell.value !== '' && cell.value !== undefined) {
                      cell.alignment = {
                        horizontal: 'right',
                        vertical: 'middle'
                      };
                      cell.numFmt = '#,##0.00';
                    }
                  });
                }); // ========== 合并单元格 ==========
                // 按productionOrder分组合并"订单号"(A列)和"订单小计"(J列)

                dataStartRow = 5; // 第1行数据行

                Object.values(groupMap).forEach(function (indices) {
                  if (indices.length <= 1) return;
                  var startRow = dataStartRow + indices[0];
                  var endRow = dataStartRow + indices[indices.length - 1]; // 合并订单号列 (A)

                  ws.mergeCells(startRow, 1, endRow, 1); // 合并订单小计列 (J)，只保留最后一个单元格的值

                  var lastSubtotalCell = ws.getCell(endRow, 10).value;
                  ws.mergeCells(startRow, 10, endRow, 10);
                  var mergedCell = ws.getCell(startRow, 10);
                  mergedCell.value = lastSubtotalCell;
                  mergedCell.alignment = {
                    horizontal: 'right',
                    vertical: 'middle'
                  };
                  mergedCell.numFmt = '#,##0.00';
                }); // 对合并后的订单号列设置居中对齐

                Object.values(groupMap).forEach(function (indices) {
                  if (indices.length <= 1) return;
                  var startRow = dataStartRow + indices[0];
                  var endRow = dataStartRow + indices[indices.length - 1]; // 垂直居中

                  for (var r = startRow; r <= endRow; r++) {
                    var cell = ws.getCell(r, 1);
                    cell.alignment = {
                      horizontal: 'center',
                      vertical: 'middle'
                    };
                  }
                }); // ========== 生成并下载 ==========

                _context2.next = 50;
                return workbook.xlsx.writeBuffer();

              case 50:
                buffer = _context2.sent;
                blob = new Blob([buffer], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                url = URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = url;
                filename = '报价导出_' + new Date().toISOString().slice(0, 10) + '.xlsx';
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                this.$message.success('报价导出成功');

              case 62:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function exportQuotations() {
        return _exportQuotations.apply(this, arguments);
      }

      return exportQuotations;
    }()
  }
};
exports.default = _default2;